export var getCardStyles = function (borderRadius, shadowSize) { return "rounded-".concat(borderRadius, " shadow-").concat(shadowSize, " bg-white"); };
//# sourceMappingURL=card.styles.js.map